import styled from 'styled-components';

import { EllipseStyled } from '@qality/common-components/src/atoms/Ellipse';

export const ComponentContainerStyled = styled.div`
  min-width: 300px;
  width: 100%;
`;

export const EmptyComponentContainerStyled = styled.div`
  min-width: 150px;
  width: 100%;
`;

export const SummaryWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const StatusesWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  margin-top: 4px;
`;

export const BugsContainerStyled = styled.div`
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;

export const IconContainerStyled = styled.div`
  cursor: pointer;
  height: 24px;
`;

export const DotSymbolStyled = styled(EllipseStyled)`
  margin: 0 8px;
`;

export const BugsResolvedTextStyled = styled.span`
  color: var(--ds-text-accent-green, var(--ds-fb-text-accent-green));
  font-size: 12px;
`;

export const BugsSummaryTextStyled = styled.span`
  font-size: 12px;
`;

export const BugsListBannerStyled = styled.div`
  margin-top: 24px;
`;

export const LinkWrapperStyled = styled.div<{ maxWidth?: string }>`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  ${({ maxWidth }) => `max-width: ${maxWidth};`}
`;

LinkWrapperStyled.defaultProps = {
  maxWidth: '200px',
};

export const DateWrapperStyled = styled.div`
  min-width: 100px;
`;
